// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".event-code-pills-strip_c8aaad23{margin-bottom:0}.event-code-pills-strip__font_f7aac05e{font-weight:normal}", ""]);
// Exports
export var eventCodePillsStrip = "event-code-pills-strip_c8aaad23";
export var eventCodePillsStripFont = "event-code-pills-strip__font_f7aac05e";
export default ___CSS_LOADER_EXPORT___;
